import { Empty, Spin } from 'antd';
import { Dfs2SpectralResponse, IWaveSpectraTimeseries } from '../../../../../../types/waveSpectra';
import ErrorDisplay from '../../ErrorDisplay';
import styles from './WaveSpectra.module.scss';
import { WaveSpectraHeatmaps } from './WaveSpectraHeatmaps';

const NO_WAVE_SPECTRA_AVAILABLE =
  'Wave spectral analysis is not available at this point and/or dataset' as const;

interface WaveSpectraChartProps {
  data: Dfs2SpectralResponse | undefined;
  timeseries: IWaveSpectraTimeseries | null;
  error: Error | null;
  isFetching: boolean;
  hasSubmitted: boolean;
  isAvailable: boolean;
  isSpectraCoverageMissing: boolean;
  isDateRangeBlocked: boolean;
  spectraBlockedMessage: string;
}

export const WaveSpectraChart = ({
  data,
  timeseries,
  error,
  isFetching,
  hasSubmitted,
  isAvailable,
  isSpectraCoverageMissing,
  isDateRangeBlocked,
  spectraBlockedMessage,
}: WaveSpectraChartProps) => {
  if (!isAvailable) {
    return (
      <div className={styles.waveSpectra__unavailableMessage}>{NO_WAVE_SPECTRA_AVAILABLE} </div>
    );
  }

  if (isFetching) {
    return (
      <div className={styles.waveSpectra__chartLoading}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return <ErrorDisplay error={error.message} />;
  }

  if (!hasSubmitted || !data?.derived?.[0]?.S_f?.length) {
    return (
      <div className={styles.waveSpectra__empty}>
        {isDateRangeBlocked ? (
          <div className={styles.waveSpectra__unavailableMessage}>{spectraBlockedMessage}</div>
        ) : isSpectraCoverageMissing ? (
          <div className={styles.waveSpectra__unavailableMessage}>
            Wave Spectra is not available at this point
          </div>
        ) : (
          <Empty
            description={hasSubmitted ? 'No data available' : 'Press Update to load wave spectra'}
          />
        )}
      </div>
    );
  }

  return (
    <div id="Analytics-WaveSpectra-Plot" className={styles.waveSpectra__plot}>
      <WaveSpectraHeatmaps data={data} timeseries={timeseries} />
    </div>
  );
};
